<template>
  <div class="users">
    <va-card>
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="researchTerm"
            :placeholder="$t('user.search')"
            @input="searchUser"
          >
            <va-icon
              name="fa fa-search"
              slot="prepend"
            />
          </va-input>
        </div>

        <div class="flex xs12 md3">
          <div class="row row-inside">
            <va-button @click="createUser">Ajouter un utilisateur</va-button>
          </div>
        </div>

        <div class="flex xs12 md2">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
          />
        </div>
      </div>
      <va-data-table
        class="va-table--hoverable va-table--stripped"
        :fields="fields"
        :data="filteredUsers"
        :no-data-label="$t('poissonnierTable.empty')"
        :per-page="parseInt(perPage)"
        @row-clicked="showUser"
        clickable
      >
        <template
          slot="actions"
          slot-scope="props"
        > <va-popover
            message="Autoriser l'accès à l'utilisateur"
            placement="left"
          >
            <va-button
              flat
              small
              :color="props.rowData.revoked ? 'grey' : 'success'"
              icon="fa fa-check"
              @click="revokeUser(props.rowData, false)"
            />
          </va-popover>
          <va-popover
            message="Interdire l'accès à l'utilisateur"
            placement="left"
          >
            <va-button
              flat
              small
              :color="props.rowData.revoked ? 'danger' : 'grey'"
              icon="fa fa-close"
              @click="revokeUser(props.rowData, true)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>

    <va-modal
      class="modal"
      v-model="showUserTrigger"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      max-width="100%"
      v-on:ok="saveUser"
      v-on:cancel="closeModal"
    >
      <div class="row forcewidth2">
        <div class="flex md12 mb-2">
          <h5 :style="{ color: this.$themes.info }">Utilisateurs:</h5>
        </div>
        <div class="flex md12">
          <div class="row row-inside">
            <div class="flex xs10 md4 padded-right">
              <va-input
                v-model="userNom"
                placeholder="Nom"
                label="Nom"
              />
            </div>
            <div class="flex xs10 md4 padded-left padded-right">
              <va-input
                v-model="userPrenom"
                placeholder="Prénom"
                label="Prénom"
              />
            </div>
            <div class="flex md4 xs5">
              <va-select
                label="Droits"
                v-model="selectRight"
                textBy="description"
                :options="droitsOptions"
              />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex xs10 md8 padded-right">
              <va-input
                v-model="userEmail"
                placeholder="Courriel"
                label="Courriel"
                type="email"
                :success="emailChecker"
                :error="emailError"
                :error-messages="errorMsgEmail"
              />
            </div>
            <div class="flex xs10 md4">
              <va-input
                v-model="userName"
                placeholder="Username"
                label="Username"
                :error="userNameEmpty.check"
                :error-messages="userNameEmpty.message"
              />
            </div>
          </div>
          <div
            class="row row-inside"
            v-show="isNotNewUser"
          >
            <div class="flex xs10 md4">
              <va-checkbox
                label="Réinitialiser le mot de passe"
                v-model="resetPassword"
              />
            </div>
          </div>
          <div
            class="row row-inside"
            v-show="resetPassword"
          >
            <div class="flex xs10 md4">
              <va-checkbox
                label="Envoyer le mot de passe"
                v-model="sendByEmail"
                disabled
              />
            </div>
          </div>
          <div
            class="row row-inside"
            v-show="resetPassword && !sendByEmail"
          >
            <div class="flex xs10 md6 padded-right">
              <va-input
                v-model="password"
                placeholder="Mot de passe"
                label="Mot de passe"
                type="password"
                :success="pwdSuccess"
                :error="pwdChecker.check"
                :error-messages="pwdChecker.message"
              />
            </div>
            <div class="flex xs10 md6 padded-left">
              <va-input
                v-model="passwordCheck"
                placeholder="Mot de passe"
                label="Vérifier le mot de passe"
                type="password"
                :success="pwdSuccess"
                :error="pwdChecker.check"
                :error-messages="pwdChecker.message"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row row-inside">
        <div class="flex md12 mt-4 mb-2">
          <h5 :style="{ color: this.$themes.info }">Gestion des droits:</h5>
        </div>
      </div>

      <div class="row row-inside">
        <div class="flex md2">
          <div class="row row-inside">
            <va-checkbox v-model="poissonneriesAccess" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Poissonneries</span>
          </div>
          <div
            class="row row-inside"
            v-if="poissonneriesAccess"
          >
            <va-checkbox v-model="canDelete" />
            <span class="checkbox-label--secondary">Suppression fiche</span>
          </div>
          <div
            class="row row-inside"
            v-if="poissonneriesAccess"
          >
            <va-checkbox v-model="canCreate" />
            <span class="checkbox-label--secondary">Création fiche</span>
          </div>
        </div>
        <div class="flex md2">
          <div class="row row-inside">
            <va-checkbox v-model="partenairesAccess" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Partenaires</span>
          </div>
          <div
            class="row row-inside"
            v-if="partenairesAccess"
          >
            <va-checkbox v-model="canDeletePartenaires" />
            <span class="checkbox-label--secondary">Suppression fiche</span>
          </div>
          <div
            class="row row-inside"
            v-if="partenairesAccess"
          >
            <va-checkbox v-model="canCreatePartenaires" />
            <span class="checkbox-label--secondary">Création fiche</span>
          </div>
        </div>
        <div class="flex md2">
          <div class="row row-inside">
            <va-checkbox v-model="adherentsAccess" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Adhérents</span>
          </div>
          <div
            class="row row-inside"
            v-if="adherentsAccess"
          >
            <va-checkbox v-model="unpf" />
            <span class="checkbox-label--secondary">UNPF</span>
          </div>
          <div
            class="row row-inside"
            v-if="adherentsAccess"
          >
            <va-checkbox v-model="spef" />
            <span class="checkbox-label--secondary">SPEF</span>
          </div>
        </div>
        <div class="flex md2">
          <div class="row row-inside">
            <va-checkbox v-model="campagnesAccess" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Campagne d'adhésion</span>
          </div>
          <div
            class="row row-inside"
            v-if="campagnesAccess"
          >
            <va-checkbox v-model="campagnesUnpfAccess" />
            <span class="checkbox-label--secondary">UNPF</span>
          </div>
          <div
            class="row row-inside"
            v-if="campagnesAccess"
          >
            <va-checkbox v-model="campagnesSpefAccess" />
            <span class="checkbox-label--secondary">SPEF</span>
          </div>
        </div>
        <div class="flex md2">
          <div class="row row-inside">
            <va-checkbox v-model="communications" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >communications</span>
          </div>
          <div
            class="row row-inside"
            v-if="communications"
          >
            <va-checkbox v-model="mapa" />
            <span class="checkbox-label--secondary">Export MAPA</span>
          </div>
          <div class="row row-inside">
            <va-checkbox v-model="exportsList" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Exports</span>
          </div>
        </div>
        <div class="flex md2">
          <div class="row row-inside">
            <va-checkbox v-model="utilisateursAccess" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Utilisateurs</span>
          </div>
          <div class="row row-inside">
            <va-checkbox v-model="journalAccess" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Journal</span>
          </div>
          <div class="row row-inside">
            <va-checkbox v-model="prelevementsAccess" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Prélèvements</span>
          </div>
          <div class="row row-inside">
            <va-checkbox v-model="adhesionsTierces" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Adhésions Tierces</span>
          </div>
          <div class="row row-inside">
            <va-checkbox v-model="retoursVar" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Module de gestion des retours</span>
          </div>
          <div class="row row-inside">
            <va-checkbox v-model="afpfVar" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >AFPF</span>
          </div>
          <div class="row row-inside">
            <va-checkbox v-model="renouvellementsVar" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Renouvellements d'adhésion</span>
          </div>
        </div>
      </div>
      <div class="row row-inside">
        <div class="flex md3">
          <div class="row row-inside">
            <va-checkbox v-model="publicationsVar" />
            <span
              class="checkbox-label"
              :style="{ color: this.$themes.info }"
            >Module publications / annonceurs</span>
          </div>
          <div
            class="row row-inside"
            v-if="publicationsVar"
          >
            <va-checkbox v-model="publicationModifications" />
            <span class="checkbox-label--secondary">Gestion des devis / factures</span>
          </div>
          <div
            class="row row-inside"
            v-if="publicationsVar"
          >
            <va-checkbox v-model="publicationsNumeros" />
            <span class="checkbox-label--secondary">Gestion des numéros</span>
          </div>
        </div>
      </div>
    </va-modal>

    <va-modal
      class="modal"
      v-model="showConfirmDelete"
      title="Suppression de l'utilisateur"
      :message="confirmDeleteMsg"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      max-width="100%"
      v-on:ok="confirmDelete"
      v-on:cancel="closeDeleteModal"
    />

    <va-modal
      class="modal"
      v-model="showConfirmRevoke"
      title="Blocage de l'utilisateur"
      :message="confirmRevokeMsg"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      max-width="100%"
      v-on:ok="confirmRevoke"
      v-on:cancel="closeRevokeModal"
    />
  </div>
</template>

<script>
import axios from "axios";
import { debounce, findIndex } from "lodash";
import { validateEmail } from "../../services/utils";

export default {
  name: "users",

  data() {
    return {
      justLoaded: false,
      showConfirmDelete: false,
      confirmDeleteMsg: null,
      isAction: false,
      pwdEmpty: false,
      userNameEmpty: {
        check: false,
        message: ["L'email ou l'username doit exister"],
      },
      idutilisateurs: null,
      errorMsgEmail: null,
      isNotNewUser: false,
      resetPassword: true,
      sendByEmail: false,
      selectRight: 1,
      userName: null,
      userNom: null,
      userPrenom: null,
      userEmail: null,
      password: null,
      passwordCheck: null,
      researchTerm: null,
      poissonneriesAccess: false,
      partenairesAccess: false,
      utilisateursAccess: false,
      journalAccess: false,
      prelevementsAccess: false,
      adherentsAccess: false,
      campagnesAccess: false,
      campagnesUnpfAccess: false,
      campagnesSpefAccess: false,
      unpf: true,
      spef: true,
      mapa: false,
      exportsList: false,
      communications: false,
      canDelete: false,
      canCreate: false,
      canDeletePartenaires: false,
      canCreatePartenaires: false,
      adhesionsTierces: false,
      publicationsVar: false,
      publicationsNumeros: false,
      publicationModifications: false,
      retoursVar: false,
      afpfVar: false,
      renouvellementsVar: false,
      perPage: 20,
      usersList: [],
      showUserTrigger: false,
      perPageOptions: ["4", "6", "10", "20"],
      droitsOptions: [
        { id: 0, description: "ADMIN" },
        { id: 1, description: "UTILISATEUR" },
      ],
      activeUser: null,
      activeUserRevoke: null,
      showConfirmRevoke: false,
      revoke: false,
      confirmRevokeMsg: null,
    };
  },
  methods: {
    closeRevokeModal() {
      this.activeUserRevoke = null;
      this.revoke = false;
    },
    closeDeleteModal() {
      this.activeUser = null;
    },
    confirmRevoke() {
      axios
        .post("api/revoke-user", { user: this.activeUserRevoke, revoked: this.revoke })
        .then((res) => {
          this.launchEpicmaxToast(this.revoke ? "Utilisateur débloqué" : "Utilisateur bloqué");
          this.loadUserList();
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
          this.launchEpicmaxToast("Erreur lors du blocage/déblocage");
          this.loadUserList();
        });

      this.showConfirmRevoke = false;
      this.activeUserRevoke = null;
      this.revoke = false;
    },
    confirmDelete() {
      axios
        .delete("api/delete-user", { data: { user: this.activeUser } })
        .then((res) => {
          this.launchEpicmaxToast("Utilisateur supprimé");
          this.loadUserList();
        })
        .catch((err) => {
          this.launchEpicmaxToast("Erreur lors de la suppression");
          this.loadUserList();
        });

      this.showConfirmDelete = false;
    },
    revokeUser(user, revoked) {
      this.isAction = true;
      this.confirmRevokeMsg =
        "Voulez vous vraiment bloquer l'utilisateur? \n Username: " +
        user.username +
        "\n Email: " +
        user.email;
      this.activeUserRevoke = user;
      this.showConfirmRevoke = true;
      this.revoke = revoked;
    },
    deleteUser(user) {
      this.isAction = true;
      this.confirmDeleteMsg =
        "Voulez vous vraiment supprimer l'utilisateur? \n Username: " +
        user.username +
        "\n Email: " +
        user.email;
      this.activeUser = user;
      this.showConfirmDelete = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    searchUser: debounce(function (researchTerm) {
      this.researchTerm = researchTerm;
    }, 400),
    resetUser() {
      this.isNotNewUser = false;
      this.resetPassword = true;
      this.sendByEmail = false;
      this.selectRight = this.droitsOptions[1];
      this.userName = null;
      this.userNom = null;
      this.userPrenom = null;
      this.userEmail = null;
      this.password = null;
      this.passwordCheck = null;
      this.userNameEmpty.check = false;
      this.idutilisateurs = null;
      this.poissonneriesAccess = false;
      this.partenairesAccess = false;
      this.utilisateursAccess = false;
      this.journalAccess = false;
      this.prelevementsAccess = false;
      this.adherentsAccess = false;
      this.campagnesAccess = false;
      this.campagnesUnpfAccess = false;
      this.campagnesSpefAccess = false;
      this.canDelete = false;
      this.canCreate = false;
      this.canDeletePartenaires = false;
      this.canCreatePartenaires = false;
      this.unpf = true;
      this.spef = true;
      this.mapa = true;
      this.exportsList = true;
      this.communications = true;
      this.adhesionsTierces = false;
      this.publicationsVar = false;
      this.publicationsNumeros = false;
      this.publicationModifications = false;
      this.retoursVar = false;
      this.afpfVar = false;
      this.renouvellementsVar = false;
    },
    setUser(user) {
      //used to not reset the right of someone that is just loaded
      this.justLoaded = true;
      this.isNotNewUser = true;
      this.resetPassword = false;
      this.sendByEmail = false;
      this.selectRight =
        user.droits === "ADMIN" ? this.droitsOptions[0] : this.droitsOptions[1];
      this.userName = user.username;
      this.idutilisateurs = user.idutilisateurs;
      this.userNom = user.nom;
      this.userPrenom = user.prenom;
      this.userEmail = user.email;
      this.password = null;
      this.passwordCheck = null;
      this.poissonneriesAccess = user.poissonneries;
      this.partenairesAccess = user.partenaires;
      this.utilisateursAccess = user.utilisateurs;
      this.adherentsAccess = user.adherents;
      this.campagnesAccess = user.campagnes;
      this.campagnesUnpfAccess = user.campagnes_unpf;
      this.campagnesSpefAccess = user.campagnes_spef;
      this.canDelete = user.suppression_entreprises;
      this.canCreate = user.creation_entreprise;
      this.canDeletePartenaires = user.suppression_partenaires;
      this.canCreatePartenaires = user.creation_partenaires;
      this.journalAccess = user.journal;
      this.prelevementsAccess = user.prelevements;
      this.unpf = user.unpf;
      this.spef = user.spef;
      this.mapa = user.mapa;
      this.exportsList = user.exports;
      this.communications = user.communications;
      this.adhesionsTierces = user.adhesions_tierces;
      this.publicationsVar = user.publications;
      this.publicationsNumeros = user.publications_numeros;
      this.publicationModifications = user.publication_modifications;
      this.renouvellementsVar = user.renouvellements;
      this.retoursVar = user.retours;
      this.afpfVar = user.afpf;
    },
    showUser(user) {
      if (this.isAction) {
        this.isAction = false;
        return;
      }
      this.isNotNewUser = true;
      this.setUser(user);
      this.showUserTrigger = true;
    },
    closeModal() {
      this.resetUser();
      this.showUserTrigger = false;
    },
    async saveUser() {
      //intercept and prevent modal closing
      this.showUserTrigger = true;

      let interupt = false;
      this.pwdEmpty = false;

      // check that everything mandatory is set:
      if (!this.userName && (!this.userEmail || this.emailError)) {
        this.userNameEmpty.check = true;
        interupt = true;
      }

      if (
        !this.sendByEmail &&
        (this.resetPassword || !this.isNotNewUser) &&
        (!this.password || this.pwdChecker.check)
      ) {
        this.pwdEmpty = true;
        interupt = true;
      }
      if (interupt) {
        this.launchEpicmaxToast("L'utilisateur ne peut pas être créé");
        return;
      }

      if (!this.poissonneriesAccess) {
        this.canDelete = false;
        this.canCreate = false;
      }

      if (!this.partenairesAccess) {
        this.canDeletePartenaires = false;
        this.canCreatePartenaires = false;
      }

      if (!this.adherentsAccess) {
        this.unpf = false;
        this.spef = false;
      }
      if (!this.campagnesAccess) {
        this.campagnesUnpfAccess = false;
        this.campagnesSpefAccess = false;
      }
      if (!this.communications) {
        this.mapa = false;
      }

      let params = {
        userName: this.userName,
        email: this.userEmail,
        prenom: this.userPrenom,
        nom: this.userNom,
        droits: this.selectRight,
        password: this.password,
        poissonneries: this.poissonneriesAccess,
        partenaires: this.partenairesAccess,
        adherents: this.adherentsAccess,
        utilisateurs: this.utilisateursAccess,
        campagnes: this.campagnesAccess,
        campagnes_unpf: this.campagnesUnpfAccess,
        campagnes_spef: this.campagnesSpefAccess,
        suppression_entreprises: this.canDelete,
        creation_entreprise: this.canCreate,
        suppression_partenaires: this.canDeletePartenaires,
        creation_partenaires: this.canCreatePartenaires,
        journal: this.journalAccess,
        prelevements: this.prelevementsAccess,
        unpf: this.unpf,
        spef: this.spef,
        mapa: this.mapa,
        communications: this.communications,
        // to send a reset email
        resetEmail: this.sendByEmail,
        resetPwd: this.resetPassword,
        adhesions_tierces: this.adhesionsTierces,
        publications: this.publicationsVar,
        publications_numeros: this.publicationsNumeros,
        publication_modifications: this.publicationModifications,
        renouvellements: this.renouvellementsVar,
        retours: this.retoursVar,
        afpf: this.afpfVar,
        exports: this.exportsList,
      };
      // change url based on context (create or update)
      let url;
      if (this.isNotNewUser) {
        url = "update-user";
        params.idutilisateurs = this.idutilisateurs;
      } else {
        url = "create-user";
      }

      axios
        .post("/api/" + url, params)
        .then((res) => {
          this.loadUserList();
          this.showUserTrigger = false;
        })
        .catch((err) => {
          console.log(err.response.data);
          this.launchEpicmaxToast("L'utilisateur ne peut pas être créé");
        });
    },
    containSearch(term) {
      return term.toLowerCase().includes(this.researchTerm.toLowerCase());
    },
    createUser() {
      this.isNotNewUser = false;
      this.resetUser();
      this.showUserTrigger = true;
    },
    loadUserList() {
      axios.get("/api/users-list").then((resp) => {
        this.usersList = resp.data;
      });
    },
  },
  mounted() {
    this.loadUserList();
  },
  computed: {
    emailError() {
      if (this.userNameEmpty.check) {
        this.errorMsgEmail = this.userNameEmpty.message;
        return true;
      }

      if (!this.userEmail || this.userEmail.length < 1 || this.emailChecker) {
        this.errorMsgEmail = ["Courriel non valide"];
        return false;
      }

      this.errorMsgEmail = this.userNameEmpty.message;
      return true;
    },
    emailChecker() {
      return validateEmail(this.userEmail);
    },
    pwdSuccess() {
      if (
        this.passwordCheck &&
        this.password &&
        this.passwordCheck === this.password
      )
        return true;

      return false;
    },
    pwdChecker() {
      if (this.pwdEmpty) {
        return {
          check: true,
          message: ["Le mot de passe ne peut pas être vide"],
        };
      }
      if (
        !this.passwordCheck ||
        this.passwordCheck.length < 1 ||
        this.passwordCheck === this.password
      )
        return {
          check: false,
        };

      return {
        check: true,
        message: ["Les mots de passes doivent correspondre"],
      };
    },
    filteredUsers() {
      if (!this.researchTerm || this.researchTerm.length < 1) {
        return this.usersList;
      }
      return this.usersList.filter((item) => {
        return (
          this.containSearch(item.nom) ||
          this.containSearch(item.prenom) ||
          this.containSearch(item.username) ||
          this.containSearch(item.email)
        );
      });
    },
    fields() {
      return [
        {
          name: "nom",
          title: "Nom",
          sortField: "nom",
          width: "15%",
        },
        {
          name: "prenom",
          title: "Prénom",
          sortField: "prenom",
          width: "15%",
        },
        {
          name: "username",
          title: "Username",
          sortField: "username",
          width: "15%",
        },
        {
          name: "email",
          title: "Courriel",
          sortField: "email",
          width: "35%",
        },
        {
          name: "droits",
          title: "Droits",
          sortField: "droits",
          width: "10%",
        },
        {
          name: "__slot:actions",
          dataClass: "text-right",
          width: "10%",
        },
      ];
    },
  },
  watch: {
    selectRight(newvalue) {
      if (!this.justLoaded) {
        if (newvalue.description === "ADMIN") {
          this.poissonneriesAccess = true;
          this.partenairesAccess = true;
          this.adherentsAccess = true;
          this.utilisateursAccess = true;
          this.journalAccess = true;
          this.prelevementsAccess = true;
          this.campagnesAccess = true;
          this.campagnesUnpfAccess = true;
          this.campagnesSpefAccess = true;
          this.canDelete = true;
          this.canCreate = true;
          this.canDeletePartenaires = true;
          this.canCreatePartenaires = true;
          this.mapa = true;
          this.exportsList = true;
          this.communications = true;
          this.adhesionsTierces = true;
          this.publicationsVar = true;
          this.publicationsNumeros = true;
          this.publicationModifications = true;
          this.retoursVar = true;
          this.afpfVar = true;
          this.renouvellementsVar = true;
        } else {
          this.poissonneriesAccess = false;
          this.partenairesAccess = false;
          this.adherentsAccess = false;
          this.utilisateursAccess = false;
          this.journalAccess = false;
          this.prelevementsAccess = false;
          this.campagnesAccess = false;
          this.campagnesUnpfAccess = false;
          this.campagnesSpefAccess = false;
          this.canDelete = false;
          this.canCreate = false;
          this.canDeletePartenaires = false;
          this.canCreatePartenaires = false;
          this.mapa = false;
          this.exportsList = false;
          this.communications = false;
          this.adhesionsTierces = false;
          this.publicationsVar = false;
          this.publicationsNumeros = false;
          this.publicationModifications = false;
          this.retoursVar = false;
          this.afpfVar = false;
          this.renouvellementsVar = false;
        }
      } else {
        this.justLoaded = false;
      }
    },
  },
};
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}

.padded-right {
  padding-right: 1%;
}
.padded-left {
  padding-left: 1%;
}
.forcewidth2 {
  min-width: 85vw;
}

.checkbox-label {
  position: relative;
  top: 0.2em;
  font-weight: bold;
}
.checkbox-label--secondary {
  position: relative;
  top: 0.25em;
  font-weight: bold;
  font-size: 0.8em;
}
</style>
